import 'intersection-observer';

let disqusLoaded = false;

const loadDisqus = () => {
  console.log('Load Disqus');
  if (disqusLoaded) {
    return;
  }
  const d = document, s = d.createElement('script');
  s.src = '//siipola.disqus.com/embed.js';
  s.setAttribute('data-timestamp', + new Date());
  (d.head || d.body).appendChild(s);
  disqusLoaded = true;
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('disqus_thread')) {
    const io = new IntersectionObserver(entries => {
      if(entries[0].intersectionRatio !== 0) {
        loadDisqus();
      }
    }, {
      rootMargin: '2000px',
    });
    io.observe(document.getElementById('disqus_thread'));
  }
});
